import { Link } from "react-router-dom";
import SystemStatusPill from "./SystemStatusPill";

export const Footer = () => {  return (
    <footer data-testid="site-footer" className="bg-[#0A192F] text-white/70 py-14 border-t border-[#C5A059]/20">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-12 grid sm:grid-cols-2 lg:grid-cols-4 gap-10">
        <div>
          <div className="flex items-center gap-3 mb-4">
            <div className="w-9 h-9 border border-[#C5A059] flex items-center justify-center">
              <span className="font-display text-[#C5A059]">A</span>
            </div>
            <div>
              <div className="font-display text-white">AIGL Channel</div>
              <div className="font-accent text-[10px] text-[#C5A059]">Career Launch</div>
            </div>
          </div>
          <p className="text-sm leading-relaxed">
            Investor-ready business plans for ambitious founders. Instant Business-in-a-Box.
          </p>
        </div>

        <div>
          <h5 className="font-accent text-[11px] text-white mb-4">EXPLORE</h5>
          <ul className="space-y-2 text-sm">
            <li><a data-testid="footer-products" href="/#products" className="hover:text-[#C5A059]">Business Plans</a></li>
            <li><a data-testid="footer-why" href="/#why" className="hover:text-[#C5A059]">Why AIGL</a></li>
            <li><a data-testid="footer-testimonials" href="/#testimonials" className="hover:text-[#C5A059]">Reviews</a></li>
            <li><a data-testid="footer-faq" href="/#faq" className="hover:text-[#C5A059]">FAQ</a></li>
            <li><Link data-testid="footer-about" to="/about" className="hover:text-[#C5A059]">About Us</Link></li>
          </ul>
        </div>

        <div>
          <h5 className="font-accent text-[11px] text-white mb-4">SUPPORT</h5>
          <ul className="space-y-2 text-sm">
            <li>
              <a
                data-testid="footer-support-email"
                href="mailto:aiglchannel.info@gmail.com"
                className="hover:text-[#C5A059]"
              >
                aiglchannel.info@gmail.com
              </a>
            </li>
            <li>
              <Link data-testid="footer-support" to="/support" className="hover:text-[#C5A059]">
                App Store Support
              </Link>
            </li>
            <li>
              <Link data-testid="footer-privacy" to="/privacy" className="hover:text-[#C5A059]">
                Privacy Policy
              </Link>
            </li>
            <li>Instant digital delivery</li>
          </ul>
        </div>

        <div>
          <h5 className="font-accent text-[11px] text-white mb-4">SECURE PAYMENT</h5>
          <p className="text-sm leading-relaxed">
            Powered by Stripe &amp; PayPal. 256-bit SSL encryption. We never store your card details.
          </p>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-12 pt-10 mt-10 border-t border-white/10 text-xs flex flex-col sm:flex-row justify-between items-start sm:items-center gap-3">
        <span>&copy; {new Date().getFullYear()} AIGL Channel. All rights reserved.</span>
        <div className="flex flex-col sm:flex-row items-start sm:items-center gap-3 sm:gap-5">
          <div className="flex items-center gap-4">
            <Link data-testid="footer-bottom-privacy" to="/privacy" className="hover:text-[#C5A059]">Privacy</Link>
            <Link data-testid="footer-bottom-support" to="/support" className="hover:text-[#C5A059]">Support</Link>
          </div>
          <SystemStatusPill mode="dark" />
          <span>USD &middot; GBP &middot; EUR &middot; Global delivery</span>
        </div>
      </div>
    </footer>
  );
};
